import {EnvioAditivoComponent} from './components/envio-aditivo/envio-aditivo.component';
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginViaPRCComponent} from './components/login-via-prc.component.ts/login-via-prc.component';
import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";
import {ConsultaAditivoComponent} from './components/consulta-aditivo/consulta-aditivo.component';
import {PesquisaPacComponent} from './components/pesquisa-pac/pesquisa-pac.component';
import {PesquisaAditivoComponent} from './components/pesquisa-aditivo/pesquisa-aditivo.component';
import {
  PesquisaInternaAditivoComponent
} from './components/pesquisa-interna-aditivo/pesquisa-interna-aditivo.component';
import {AnalisaAditivoComponent} from './components/analisa-aditivo/analisa-aditivo.component';
import {HomeComponent} from "./components/home/home.component";
import { PesquisaPropostaComponent } from './components/pesquisa-proposta/pesquisa-proposta.component';

import {DetalheDaPropostaComponent} from './components/exibicao-proposta/detalhe-da-proposta/detalhe-da-proposta.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginViaPRCComponent,
    canActivate: []
  },
  {
    path: 'analisa-aditivo',
    component: PesquisaInternaAditivoComponent,
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'analisa-aditivo/:id',
    component: AnalisaAditivoComponent,
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'envio-aditivo',
    component: PesquisaPacComponent,
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'envio-aditivo/:id',
    component: EnvioAditivoComponent,
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'consulta-aditivo',
    component: PesquisaAditivoComponent,
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'consulta-aditivo/:id',
    component: ConsultaAditivoComponent,
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'pesquisa-proposta',
    component: PesquisaPropostaComponent,
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'detalhe-proposta/:numeroPAC',
    component: DetalheDaPropostaComponent,
    canActivate: [AuthenticationGuard]
  },
  {
    path: '',
    component: PesquisaPropostaComponent,
    canActivate: [AuthenticationGuard]
  },


  // {
  //   path: '',
  //   component: <algum_component>
  // },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash: true
})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
